import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { ComponentData } from '../../data/ComponentContext'
import ColorCheckbox from '../ColorCheckbox'
import GeometryRadio from '../GeometryRadio'
import MaterialSelect from '../MaterialSelect'
import SurfaceRadio from '../SurfaceRadio'
import Delete from '../../img/delete.svg'
import Arrow from '../../img/arrow-right.svg'
import WeightInput from '../WeightInput'
import DimensionInputs from '../DimensionInputs'


function ComponentTab({ toNextTab, toLastTab }) {

  const { resetComponent, componentIsValid } = ComponentData()

  const [displayErrors, setDisplayErrors] = useState(false)

  return (
    <div className='component-tab'>
      <div className="content-box">
        <h2>Wie sieht Ihr Bauteil aus?</h2>
        <p>Nennen Sie die Charakteristika eines Werkstücks, das Ihr Produktportfolio gut repräsentiert.</p>
      </div>
      <div className="configuration-area">
        <Row>
          <Col md="4">
            <Row>
              <MaterialSelect className="content-box" displayErrors={displayErrors} />
            </Row>
          </Col>

          <Col md="4">
            <Row><ColorCheckbox className="content-box" displayErrors={displayErrors} /></Row>
          </Col>

          <Col md="4">
            <Row><SurfaceRadio className="content-box" displayErrors={displayErrors} /></Row>
          </Col>

        </Row>

        <Row>
          <Row className="headline_texts">
            <div className="configuration-text">
              <p>Wählen Sie die primäre Bauteilgeometrie</p>
              <h3>Geometrie</h3>
            </div>
          </Row>
          <Col md={8}>
            <Row>
              <GeometryRadio className="content-box" displayErrors={displayErrors} />
            </Row>
          </Col>
          <Col md={4}>
            <Row>
              <Col md={6}>
                <DimensionInputs displayErrors={displayErrors} />
              </Col >
              <Col md={6}>
                <WeightInput displayErrors={displayErrors} className={'dimension-inputs'} />
              </Col>
            </Row>
          </Col>
        </Row>


      </div>

      <div className="button-box">
        <button className="delete" onClick={resetComponent}>Zurücksetzen <img className="button-svg" src={Delete} alt='' /></button>
        <button onClick={toLastTab}><img className="button-svg back" src={Arrow} alt='' />Zurück</button>
        <button className={componentIsValid ? '' : 'disabled'} onClick={componentIsValid ? toNextTab : () => setDisplayErrors(true)}>Weiter <img className="button-svg" src={Arrow} alt='' /></button>
      </div>

    </div>
  )
}

export default ComponentTab